import { Component, OnInit } from '@angular/core';
import { ErrorMessage } from '@shared/util-error';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  standalone: false
})
export class ErrorPageComponent implements OnInit {
  protected errorMessage: ErrorMessage = {
    summary: 'Anwendungsfehler',
    requestId: null,
    detail: 'Es ist ein Fehler aufgetreten.'
  };

  ngOnInit(): void {
    const message = history.state;
    if (message) {
      this.errorMessage = message;
    }
  }
}
